import { DetailedTableInfoDc } from "@evergis/api";
import { useCallback } from "react";
import { putTable } from "../../resources/tables";

type Update = [
  (tableInfo: DetailedTableInfoDc) => Promise<void>,
  {
    tableUpdate: DetailedTableInfoDc;
    tableUpdating: boolean;
    tableUpdateError: Error;
  },
];

export const usePutTable = (): Update => {
  const [putTableMutation, { data, loading, error }] = putTable.use();

  const update = useCallback(
    (tableInfo: DetailedTableInfoDc) =>
      putTableMutation({
        input: tableInfo,
      }),
    [putTableMutation],
  );

  return [update, { tableUpdate: data, tableUpdating: loading, tableUpdateError: error }];
};
